@if(breadcrumb()){
  <nav>
    <ul class="flex flex-wrap">
      @for (crumb of breadcrumb(); track crumb.url; let last = $last) {
        <li class="flex items-center mb-1">
          @if (!last) {
            <a
              (click)="navigateBreadcrumb(crumb)"
              class="text-custom-gray hover:text-custom-red"
            >
              {{ crumb?.title }}
            </a>
            <span class="mx-1 text-gray-400">/</span>
          } @else {
            <span class="text-custom-black ">{{ crumb?.title }}</span>
          }
        </li>
      }
    </ul>
  </nav>
}

